/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'navigation.global-shortcuts.all-sites': '所有網站',
  'navigation.global-shortcuts.apps.align': 'Align',
  'navigation.global-shortcuts.apps.analytics': '分析',
  'navigation.global-shortcuts.apps.assets': 'Assets',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': '公司中心',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': '目標',
  'navigation.global-shortcuts.apps.home': '首頁',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': '專案',
  'navigation.global-shortcuts.apps.studio': '工作室',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': '團隊',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': '關閉',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': '「{name}」網站',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(目前無法使用)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': '開啟外部連結圖示',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(載入中)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(載入中)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': '開啟選單',
  'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
  'navigation.global-shortcuts.sites': '{productName} 網站',
};
